const PlanningSites = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Planning/PlanningSites')

export const ROUTE_NAME_PLATFORM_CUSTOMER_PLANNING_SITE = 'customerPlaningSites'
export default [
  {
    path: ROUTE_NAME_PLATFORM_CUSTOMER_PLANNING_SITE,
    name: 'customerPlaningSites',
    component: PlanningSites,
    meta: {
      label: 'Sites'
    }
  }
]
